import { render, staticRenderFns } from "./Discussion.vue?vue&type=template&id=7a4f3d34"
import script from "./Discussion.vue?vue&type=script&lang=js"
export * from "./Discussion.vue?vue&type=script&lang=js"
import style0 from "./Discussion.vue?vue&type=style&index=0&id=7a4f3d34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports